if (!customElements.get('secret-fit-helper')) {
  customElements.define('secret-fit-helper', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const output = this.querySelector('[data-output]');
      const stock = this.querySelector('[data-stock]');
      this.querySelector('[data-calculate]').addEventListener('click', () => {
        stock.hidden = true;
        const order = ['XS','S','M','L','XL','XXL','3XL','4XL'];
        const step = Number(this.dataset.offset) || 0;
        let target;
        {
          const height = this.querySelector('[data-height]');
          const weight = this.querySelector('[data-weight]');
          const rawHeight = height.value.trim().replace(',', '.');
          const parsedHeight = /^\d+(?:\.\d+)?$/.test(rawHeight) ? Number(rawHeight) : NaN;
          const h = parsedHeight >= 1.5 && parsedHeight <= 2 ? parsedHeight * 100 : parsedHeight;
          if (!Number.isFinite(h) || h < 150 || h > 200 || !weight.checkValidity() || !weight.value) {
            output.textContent = this.dataset.invalid;
            return;
          }
          const w = Number(weight.value);
          const referenceWeight = w + Math.max(0, h - 175) * 0.25;
          const limits = [60,70,80,90,100,110,121,131];
          let index = limits.findIndex(limit => referenceWeight < limit);
          if (index < 0) { output.textContent = this.dataset.missing; return; }
          const numericStep = Number(this.dataset.numericOffset) || 0;
          const numericBase = numericStep === -2 ? 28 : 26;
          target = this.dataset.numeric === 'true'
            ? String(numericBase + index * 2 + numericStep)
            : order[index + step];
        }
        const normalize = x => ({'2XL':'XXL','XXXL':'3XL','XXXXL':'4XL'}[x] || x);
        const match = Array.from(this.querySelectorAll('[data-sizes] span')).find(e => normalize(e.textContent.trim().toUpperCase()) === target);
        output.textContent = match ? this.dataset.result + match.textContent : this.dataset.missing;
        stock.hidden = !match;
      });
      this.addEventListener('keydown', event => {
        if (event.key === 'Enter' && event.target.matches('input')) {
          event.preventDefault();
          this.querySelector('[data-calculate]').click();
        }
      });
      this.querySelectorAll('input,select').forEach(e => e.addEventListener('input', () => { output.textContent = ''; stock.hidden = true; }));
    }
  });
}
